<script setup>
import {useProfile} from "~/composables/useProfile.js";

const props = defineProps({
  user: {
    type: Object,
    required: true
  }
})

const {changeAccount, canChangeName, fullName, error, loading} = useProfile()

fullName.value = props.user.displayName

</script>

<template>
  <form @submit.prevent="changeAccount" class="flex flex-col gap-5" autocomplete="off">
    <ul v-if="error.account.length >= 1" class="pl-4 pr-7 py-2 space-y-1 rounded-md bg-red-90/10 border border-red-90/40 list-disc">
      <li class="text-label text-red-90" v-for="(error, index) in error.account" :key="index">{{error}}</li>
    </ul>
    <fieldset>
      <label for="fullname" class="block text-label mb-2.5">نام کامل</label>
      <div class="input-wrapper">
        <input type="text" id="fullname" class="input" v-model="fullName" data-clarity-mask="true" placeholder="نام و نام خانوادگی">
        <Icon name="linear:user"/>
      </div>
    </fieldset>
    <fieldset>
      <label for="username" class="block text-label mb-2.5">نام کاربری</label>
      <div class="input-wrapper">
        <input type="text" id="username" class="input input-filled" :value="user.username" disabled data-clarity-mask="true" placeholder="نام کاربری">
        <Icon name="linear:flag"/>
      </div>
    </fieldset>
    <fieldset>
      <label for="email" class="block text-label mb-2.5">ایمیل</label>
      <div class="input-wrapper">
        <input type="email" id="email" class="input input-filled" :value="user.email" disabled data-clarity-mask="true" placeholder="ایمیل">
        <Icon name="linear:sms"/>
      </div>
    </fieldset>
    <AppBtn class="w-30 btn-sm btn-filled-primary mr-auto mt-4" :loading="loading.account"  :disabled="!canChangeName">
      <span>ذخیره تغیرات</span>
    </AppBtn>
  </form>
</template>

<style scoped>

</style>